import { render } from "./RowWithLabel.vue?vue&type=template&id=4b122889&scoped=true"
import script from "./RowWithLabel.vue?vue&type=script&lang=js"
export * from "./RowWithLabel.vue?vue&type=script&lang=js"

import "./RowWithLabel.vue?vue&type=style&index=0&id=4b122889&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b122889"]])

export default __exports__